import { Container, Group, Modal, Text } from '@melio/penny';
import { useMelioIntl } from '@melio/platform-i18n';
import { useSubscription } from '@melio/subscriptions-sdk';

import { usePlanInfo } from '../../../utils/plans';

export type SwitchSubscriptionToYearlyModalScreenProps = {
  isOpen: boolean;
  onClose: VoidFunction;
  onChange: VoidFunction;
};

// TODO: update modal to have real data https://meliorisk.atlassian.net/browse/ME-54460
export const SwitchSubscriptionToYearlyModalScreen = ({
  isOpen,
  onClose,
  onChange,
}: SwitchSubscriptionToYearlyModalScreenProps) => {
  const { formatCurrency, formatMessage } = useMelioIntl();

  const { subscription } = useSubscription();

  const { planName } = usePlanInfo({ planId: subscription.planId });

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      header={formatMessage('activities.settings.subscriptionPlans.switchToYearly.title')}
      primaryButton={{
        label: formatMessage('activities.settings.subscriptionPlans.switchToYearly.switchButton'),
        onClick: onChange,
        variant: 'primary',
      }}
      secondaryButton={{
        label: formatMessage('activities.settings.subscriptionPlans.switchToYearly.cancelButton'),
        onClick: onClose,
        variant: 'secondary',
      }}
      data-testid="switch-subscription-to-yearly-modal"
    >
      <Container alignItems="center" width="full" justifyContent="space-between">
        <Group spacing="m" variant="vertical" hasDivider width="full">
          <Group spacing="xxxs" variant="vertical">
            <Group width="full" justifyContent="space-between">
              <Text textStyle="body2Semi">{planName}</Text>
              <Text textStyle="body2Semi">{formatCurrency(912)}</Text>
            </Group>

            <Group width="full" justifyContent="space-between">
              <Text color="neutral.darker" textStyle="body4">
                {formatMessage('activities.settings.subscriptionPlans.switchToYearly.yearly')}
              </Text>
              <Text color="neutral.darker" textStyle="body4">
                {formatMessage('activities.settings.subscriptionPlans.switchToYearly.priceDetails', {
                  usersNumber: subscription.numberOfSeats,
                  monthlyPricePerUser: formatCurrency(19, undefined, { notation: 'compact' }),
                })}
              </Text>
            </Group>
          </Group>

          <Group spacing="m" variant="vertical">
            <Group justifyContent="space-between" alignItems="flex-start">
              <Text> {formatMessage('activities.settings.subscriptionPlans.switchToYearly.subtotal')}</Text>
              <Text>{formatCurrency(912)}</Text>
            </Group>
            <Group justifyContent="space-between" alignItems="flex-start">
              {formatMessage('activities.settings.subscriptionPlans.switchToYearly.taxes')}
              <Text>{formatCurrency(71.2)}</Text>
            </Group>
          </Group>

          <Group justifyContent="space-between" alignItems="flex-start">
            <Group spacing="s" variant="vertical">
              <Text textStyle="body2Semi">
                {formatMessage('activities.settings.subscriptionPlans.switchToYearly.total')}
              </Text>
              <Text textStyle="body4" color="neutral.darker">
                {formatMessage('activities.settings.subscriptionPlans.switchToYearly.dateRange', {
                  startDate: 'Feb 12, 2024',
                  endDate: 'Feb 12, 2025',
                })}
              </Text>
            </Group>
            <Text textStyle="body1Semi">{formatCurrency(983)}</Text>
          </Group>
        </Group>
      </Container>
    </Modal>
  );
};
